'use strict'

exports = module.exports

exports.PROTOCOL_ID = '/multistream/1.0.0'

exports.errors = {
  MULTICODEC_NOT_SUPPORTED: 'ERR_MULTICODEC_NOT_SUPPORTED'
}
